import moment from 'moment'

moment.locale('pt-br')

var formatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL'
})

const utils = {
  data: () => ({
    usedColors: []
  }),
  methods: {
    getRandomColor () {
      let colors = ['red', 'blue', 'blue-grey', 'green', 'orange', 'deep-orange darken-3', 'light-green', 'lime', 'teal lighten-3', 'brown darken-1', 'deep-purple', 'pink lighten-1', 'indigo', 'blue darken-4', 'green darken-4']
      if (this.usedColors.length > 14) this.usedColors = []
      let difference = colors.filter(e => !this.usedColors.includes(e)) || []
      let color = difference[0] || 'red'
      this.usedColors.push(color)
      return color
    },
    getRandomUnique () {
      var d = new Date().getTime()
      if (window.performance && typeof window.performance.now === 'function') {
        d += performance.now()
      }
      var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (d + Math.random() * 16) % 16 | 0
        d = Math.floor(d / 16)
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16)
      })
      return uuid
    },
    addZero (i) {
      return i < 10 ? `0${i}` : i
    },
    getDate (time = true) {
      let format = (time ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY')
      return moment().format(format)
    },
    getDate_ (time = true) {
      let format = (time ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD')
      return moment().format(format)
    },
    formatCurrency (currency) {
      return formatter.format(currency)
    },
    unformatCurrency (string = ' ') {
      string = string.replace("R$ ","")
      string = string.replace(".","")
      string = string.replace(",",".")
      string = parseFloat(string)
      return(string)
    },
    formatDate (date, time = true, linebreak = false) {
      let format = (time ? `DD/MM/YYYY${(linebreak ? '[\r\n]' : ' ')}HH:mm` : 'DD/MM/YYYY')
      return (date ? moment.utc(date).format(format) : moment().format(format))
    },
    formatDateAlt (date, time = true, linebreak = false) {
      let format = (time ? `DD/MM/YYYY${(linebreak ? '[\r\n]' : ' ')}HH:mm` : 'DD/MM/YYYY')
      return (date ? moment.utc(date).format(format) : '')
    },
    formatDateLL (date) {
      return moment(date).format('dddd, DD [de] MMMM [de] YYYY')
    },
    formatTime (time) {
      return moment(time, "HH:mm:ss").format("HH:mm");
    },
    mysqlDatetimeConvert (date) {
      return moment(date)
    },
    removeTimeFromDate (datetime) {
      return datetime.split(' ')[0]
    },
    phoneMask (str) {
      let cleaned = ('' + str).replace(/\D/g, '')
      return cleaned.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
    },
    cepMask (str) {
      let cleaned = ('' + str).replace(/\D/g, '')
      return cleaned.replace(/(\d{5})(\d{3})/, '$1-$2')
    },
    cpfMask (str) {
      let cleaned = ('' + str).replace(/\D/g, '')
      return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
    },
    dataReload () {
      this.$store.dispatch('loadData')
    },
    objectCopy (item) {
      const item_ = Object.entries(Object.freeze(item))
      const item__ = {}
      item_.forEach((value_, key_) => {
        key_ = value_[0]
        value_ = value_[1]
        if (value_ && value_.constructor.name === 'Array') {
          const blank_ = []
          item__[key_] = blank_.concat(value_)
        } else {
          item__[key_] = value_
        }
      })
      return Object.assign({}, item__)
    },
    objectArrCopy (item) {
      const clone = []
      item.forEach((value, key) => {
        if (value && value.constructor.name === 'Object') {
          const item_ = Object.entries(Object.freeze(value))
          item_.forEach((value_, key_) => {
            key_ = value_[0]
            value_ = value_[1]
            if (value_ && value_.constructor.name === 'Array') {
              const blank_ = []
              value[key_] = blank_.concat(value_)
            } else {
              value[key_] = value_
            }
          })
          clone[key] = value
        }
      })
      return [ ...clone ]
    }
  }
}
export default utils
